import { appSumoLogicLogger } from './appSumoLogicLogger';

export const flushLogs = (): void => {
  appSumoLogicLogger.flushLogs();
};
